import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl, isAppOld, isEmpty, isNotEmpty, throwErrorEvent } from '../../lib/ep.js';
import { agent_roles } from '../account/bootstrap.js';
import { useOwner } from '../context/context.js';

import Tooltip from '../builder/Tooltip.js';

import CopyOptions from './elements/CopyOptions.js';

import OwnerMenu from '../ui_items/OwnerMenu.js';
import FloatingLayer from '../builder/FloatingLayer.js';
import ConvertToTemplateOptions from '../promotion/ConvertToTemplateOptions.js';
import ActionLink from '../builder/ActionLink.js';
import SectionSubtitle from '../builder/SectionSubtitle.js';
import SectionTitle from '../builder/SectionTitle.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import SaveButton from '../builder/SaveButton.js';
import { SecondaryButton } from '../builder/ActionButton.js';

const PROMO_ROLE_ADMIN = 'administrator';
const PROMO_ROLE_EDITOR = 'editor';
const PROMO_ROLE_ANALYST = 'analyst';
const PROMO_ROLE_DESIGNER = 'designer';

const ProfileMainMenu = (props) => {
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	const template_label = owner?.promotion?.TemplateLabel ?? [];

	const [ is_template, setIsTemplate ] = useState(promotion?.is_template ?? false);
	const [ custom_template, setCustomTemplate ] = useState(promotion?.CorporateTemplate ?? false);
	const [ display_custom_template_layer, setDisplayCustomTemplateLayer ] = useState(false);
	const [ as_copyable, setAsCopyable ] = useState(promotion?.copyable ?? false);
	const [ display_copy_as_demo, setDisplayCopyASDemo ] = useState(false);

	const openCustomTemplateLayer = () => {
		setDisplayCustomTemplateLayer(true);
	};

	const closeCustomTemplateLayer = (action, value) => {
		setDisplayCustomTemplateLayer(false);

		if(action != undefined) {
			switch(action) {
				case 'delete_template':
					setCustomTemplate(false);
					break;

				case 'create_template':
					setCustomTemplate(value);
					break;
			}
		}
	};

	const update_template = (_custom_template) => {
		setCustomTemplate(_custom_template);
		closeCustomTemplateLayer();
	};

	const convertToGlobalTemplate = () => {
		$.post(`/promotions/to_template/${promotion.id}`, (result) => {
			setIsTemplate(result.id);
		}, 'JSON');
	};

	const toggleCopyable = (k, v, cb) => {
		let send_attr = {};
		send_attr[k] = v;
		$.post(getRemotedbUrl(`/promotions/save/${promotion.id}`), send_attr, (r) => {
			if(r.status)setAsCopyable(v);
			if(cb!=undefined)cb();
			setDisplayCopyASDemo(false);
		}, 'JSON').fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	useEffect(() => {
		if(custom_template.labels == undefined && template_label != undefined) {
			let _labels = [];
			template_label.map((lab, i) => {
				_labels.push(lab.label_id);
			});

			let _custom_template = {...custom_template};
			_custom_template.labels = _labels;
			setCustomTemplate(_custom_template);
		}
	}, []);

	if(promotion === false) return null;
	
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const is_basic = (promotion.promo_type == '0') ? true : false;
	const new_emails = promotion?.new_emails ?? false;
	const multiparticipation = promotion?.multi_participation ?? false;
	const has_prizes = parseInt(promotion?.config?.prizes ?? false);
	const promotion_type = owner?.promotion?.PromotionType ?? false;
	const is_corporate_template = owner?.promotion?.CorporateTemplate ?? false;

	const force_login = props?.force_login ?? false;
	const has_login_enabled = props?.has_login_enabled ?? false;
	const is_collaborator = props?.is_collaborator ?? false;

	const addons = promotion?.config?.addons || {};
	const has_stats_addon = addons?.stats ?? false;

	const agent_promotion_role = props?.agent_promotion_role ?? agent_roles.ROLE_ADMIN.id;
	const role = props?.role || PROMO_ROLE_ADMIN;

	const is_analyst = (role == PROMO_ROLE_ANALYST || agent_promotion_role == agent_roles.ROLE_ANALYST.id) ? true : false;
	const is_designer = (role == PROMO_ROLE_DESIGNER || agent_promotion_role == agent_roles.ROLE_DESIGNER.id) ? true : false;
	const is_editor = (role == PROMO_ROLE_EDITOR || agent_promotion_role == agent_roles.ROLE_EDITOR.id) ? true : false;
	const is_basic_editor = (agent_promotion_role == agent_roles.ROLE_BASIC_EDITOR.id) ? true : false;
	
	const selected = props?.selected ?? false;

	const home_props = {
		url:`/promotions/profile/${promotion.id}`,
		icon:'knk-home',
		selected:(selected == 'profile') ? true : false,
		children:"Home",
	};

	let _s = {};

	if(!is_analyst) {
		/* SECTION "SETUP" ITEMS - ini */

		const queryString = window.location.search;
		const url_params = new URLSearchParams(queryString);
		const _just_created = url_params.get('just');
		const just_created = (_just_created != undefined && _just_created == '1') ? true : false;

		_s.setup = {
			title:"Set up",
			items:[{
				// TO DO: $pendingImages control after creating or copying a new promotion
				url:`/promotions/builder/${promotion.id}`,
				icon:'knk-edit',
				selected:(selected == 'builder') ? true : false,
				children:"Editor",
				class:(just_created) ? 'highlight_animation' : null,
			}, {
				enabled:true,
				url:`/emails/${(new_emails) ? 'platform' : 'index'}/${promotion.id}`,
				icon:`knk-send${(is_basic) ? ' is_addon' : ''}`,
				selected:(selected == 'emails') ? true : false,
				children:(new_emails) ? "Emails & Notifications" : "Emails",
			}, {
				enabled:(!is_basic) ? true : false,
				url:`/integrations/index/${promotion.id}`,
				icon:'knk-integrations',
				selected:(selected == 'integrations') ? true : false,
				children:"Integrations",
			}, {
				enabled:true,
				url:`/promotions/buzz/${promotion.id}`,
				icon:'knk-publish',
				selected:(selected == 'buzz') ? true : false,
				children:"Publication resources",
			}],
		}
		/* SECTION "SETUP" ITEMS - end */
	} else {
		_s.setup = {
			title:"Set up",
			items:[{
				...home_props
			}],
		}
	}

	if(!is_designer) {
		/* SECTION "PARTICIPATION" ITEMS - ini */
		_s.participation = {
			title:"Participations",
			items:[{
				enabled:true,
				url:`/users/${(multiparticipation) ? 'audience' : 'registered'}/${promotion.id}`,//18/03/2024 => Va sempre a audience
				//url:`/users/audience/${promotion.id}`,//26/03/2024 =>rollback to registered
				icon:'knk-users',
				autotranslate:false,
				selected:(selected == 'users') ? true : false,
				children:`${i18n("Users")} [${(multiparticipation) ? (promotion?.current_uniqusers ?? 0) : (promotion?.current_users ?? 0)}]`,
			}, {
				enabled:true,
				url:`/${(has_prizes) ? `prizes/${window.features?.includes('sweep_promo') ? 'draws' : 'manager'}` : 'promotions/winners'}/${promotion.id}`,
				icon:'knk-ball-drum',
				selected:(selected == 'draws') ? true : false,
				children:"Draws",
			}, {
				enabled:true,
				url:`/insights/${promotion.id}`,
				icon:`knk-stats${(is_basic && !has_stats_addon) ? ' is_addon' : ''}`,
				selected:(selected == 'stats') ? true : false,
				children:"Statistics",
			}, {
				enabled:(multiparticipation && !is_analyst && !is_designer && !is_basic_editor) ? true : false,
				url:`/security_center/${promotion.id}#main`,
				icon:'knk-shield',
				selected:(selected == 'security_center') ? true : false,
				children:"Security Center",
			}],
		};
		/* SECTION "PARTICIPATION" ITEMS - end */
	}

	if(!is_analyst && !is_designer && !is_basic_editor) {
		let enable_copy = false;
		if(promotion.upgrade_time == '' || promotion.upgrade_time == '0000-00-00 00:00:00' || promotion.upgrade_time == null) enable_copy = true;
		if(force_login && !has_login_enabled) enable_copy = false;
		if(promotion.promotion_type_id == 1) {
			const now = new Date();
			now.setFullYear( now.getFullYear() - 1 );
			const end_date = (new Date(promotion.end_date)).getTime();
			if (end_date < now.getTime()) {
				enable_copy = false;
			}
		}

		const is_old_app = isAppOld(promotion.promotion_type_id);
		const copy_disabled = (promotion?.copy_disabled ?? 'false') != 'false' ? true : false;

		let label_copy_disabled = i18n("This promotion is classified as old because it uses the old Easypromos promotion engine, and it is no longer allowed to make copies of it. Please create a new promotion of the same type using the new engine, which will offer a better user experience in terms of speed, security, and features.");
		if(promotion.promotion_type_id == '15'){
			label_copy_disabled = props.intl.formatMessage({ id:"This promotion is classified as old because it uses the old Easypromos engine, and it is no longer allowed to make copies of it. Please create a new promotion using the {label_new_app} application, which will offer a better user experience in terms of speed, security and features." }, { label_new_app:`"${i18n("Instagram Contest with Hashtag")}"`})
		}

		/* SECTION "MANAGEMENT" ITEMS - ini */
		_s.management = {
			title:"Management",
			items:[{
				enabled:(enable_copy) ? true : false,
				custom:(!is_old_app && !copy_disabled) ? <CopyOptions
					promotion={owner?.promotion ?? null}
					has_codesets={props?.has_codesets ?? false}
					has_hashtag_integrations={props?.has_hashtag_integrations ?? false}
					has_custom_domain={props?.has_custom_domain ?? false}
					promotion_type={promotion_type}
				/> : <ActionLink
					icon='knk-copy grayIcon'
					_class={{ other:'copyPromo grayText' }}
					//disabled={true}
					autotranslate={false}
					style={{ '--main-color':'170, 170, 170' }}
					tooltip={<Tooltip
						with_icon={false}
						position='top'
						autotranslate={false}
					>{label_copy_disabled}</Tooltip>}
				>{i18n("copy promotion", 'ucfirst')}</ActionLink>,
			}],
		};

		const is_superadmin = promotion?.is_superadmin ?? false;

		if(!is_old_app && is_superadmin && !(window.account_type && is_agent_admin && custom_template)) {
			_s.management.items.push({
				url:(is_template) ? `${window.panel_url}admin/apptemplates#edit/new` : null,
				onClick:(!is_template) ? () => convertToGlobalTemplate() : null,
				_target:'_blank',
				icon:'knk-page',
				rel:'nofollow',
				children:(is_template) ? "Edit global template" : "Convert to global template",
			});
		}

		if(!is_old_app && ((window.account_type && window.is_agent_admin && promotion.promo_type == '2') || true)) {
			_s.management.items.push({
				onClick:() => openCustomTemplateLayer(),
				_target:'_blank',
				icon:'knk-page',
				rel:'nofollow',
				children:(is_corporate_template) ? "Edit template" : "Convert to template",
			});
		}

		if(!is_old_app && is_superadmin && promotion.promo_type == '2') {
			_s.management.items.push({
				onClick:() => setDisplayCopyASDemo(true),
				icon:(!as_copyable) ? 'knk-star-on' : 'knk-star-off',
				rel:'nofollow',
				children:(!as_copyable) ? "Enable as copyable demo" : "Disable as a copyable demo",
			});
		}

		_s.management.items.push({
			enabled:(!is_collaborator) ? true : false,
			url:(!is_corporate_template) ? `/promotions/confirm_delete/${promotion.id}` : null,
			icon:'knk-delete',
			//icon:'knk-delete redIcon',
			tooltip:(is_corporate_template) ? <Tooltip>{`${i18n("This promotion is a template, so it can't be deleted.")} ${i18n("Please, delete the template first from the Edit Template layer.")}`}</Tooltip> : null,
			rel:'nofollow',
			selected:(selected == 'delete') ? true : false,
			children:"Delete",
		});
		/* SECTION "MANAGEMENT" ITEMS - end */
	}

	if(!is_analyst && !is_designer) {
		const tutorial_link = promotion_type?.[`link_tutorial_${(window.is_spanish) ? 'es' : 'en'}`] ?? false;
		/* SECTION "HELP" ITEMS - ini */
		_s.help = {
			title:"Help",
			items:[{
				enabled:(tutorial_link !== false && tutorial_link != '' && tutorial_link != '#') ? true : false,
				url:`${window.zendesk_base_url}${tutorial_link}`,
				icon:'knk-tip',
				_target:'_blank',
				children:"View tutorial",
			}],
		};
		/* SECTION "HELP" ITEMS - end */
	}

	return (
		<>
			<OwnerMenu
				sections={Object.values(_s)}
			/>

			{(display_custom_template_layer) && (
				<FloatingLayer
					backButton={() => closeCustomTemplateLayer()}
					_class={{ size:'small' }}
				>
					<ConvertToTemplateOptions
						callback={update_template}
						organizers={owner.organizers}
						promotion={promotion}
						template={(is_corporate_template !== false) ? is_corporate_template : null}
					/>
				</FloatingLayer>
			)}

			{(display_copy_as_demo && as_copyable) && (
				<FloatingLayer
					backButton={() => setDisplayCopyASDemo(false)}
					_class={{ size:'small' }}
				>
					<div>
						<SectionTitle>Disable copying as demo</SectionTitle>

						<SectionSubtitle>Disable for customers to copy the demo promotion, restricting any duplication of the original.</SectionSubtitle>

						<ButtonCollection in_floating={true}>
							<SaveButton
								onClick={(e, cb) => toggleCopyable('copyable', false, cb)}
							>Yes, I confirm</SaveButton>

							<SecondaryButton
								onClick={() => setDisplayCopyASDemo(false)}
							>Close</SecondaryButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}

			{(display_copy_as_demo && !as_copyable) && (
				<FloatingLayer
					backButton={() => setDisplayCopyASDemo(false)}
					_class={{ size:'small' }}
				>
					<div>
						<SectionTitle>Enable copying as demo</SectionTitle>

						<SectionSubtitle>Allows customers to copy the demo promotion to create their own versions based on the original.</SectionSubtitle>

						<ButtonCollection in_floating={true}>
							<SaveButton
								onClick={(e, cb) => toggleCopyable('copyable', true, cb)}
							>Yes, I confirm</SaveButton>

							<SecondaryButton
								onClick={() => setDisplayCopyASDemo(false)}
							>Close</SecondaryButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}
		</>
	)
};

export default injectIntl(ProfileMainMenu);